import React from 'react'
import { BooleanField, Item, TextField } from '../../../types/SitecoreAdapter'
// Legal Links Adapter
export type LegalLinksProps = Item<{
  legalLinks: Item<{
    href: TextField
    text: TextField
    title: TextField
    newWindow: BooleanField
  }>[]
}>

export const legalLinksAdapter = ({
  fields: { legalLinks },
}: LegalLinksProps) => {
  return legalLinks.map(({ fields: { href, text, title, newWindow } }) => {
    return {
      text: text && text.value,
      href: href && href.value,
      title: title && title.value,
      newWindow: newWindow.value,
    }
  })
}
